'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getTaxMethodComponent(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/taxmethods`
        const result = await axios.get(url, {
          ...costumHeader('Get Tax Method Component', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getTaxMethod(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/historytaxmenthods`
        const result = await axios.get(url, {
          ...costumHeader('Get Tax Method', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  saveTaxMethod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/historytaxmenthods`
        const result = await axios.post(url, body, costumHeader('Save Tax Method', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editTaxMethod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/historytaxmenthods/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Tax Method', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteTaxMethod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/historytaxmenthods/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Tax Method', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }